import { FC, ReactNode } from 'react';

import classes from './Warning.module.scss';

interface WarningProps {
  icon: ReactNode;
  children: ReactNode;
}

const Warning: FC<WarningProps> = ({ icon, children }) => {
  return (
    <div className={classes.warning}>
      {icon}
      <span>{children}</span>
    </div>
  );
};

export default Warning;
